import React, { Suspense, lazy } from 'react';
import { CookiesProvider } from 'react-cookie';
import { FlagsmithProvider } from 'flagsmith/react';
import flagsmith from 'flagsmith';
import Loading from './components/loading/Loading';
import config from './config/index';
const AppContainer = lazy(() => import('./containers/App'));
const { FLAGSMITH_ENV_ID } = config;
const App = () => (React.createElement(Suspense, { fallback: React.createElement(Loading, null) },
    React.createElement(CookiesProvider, null,
        React.createElement(FlagsmithProvider, { options: {
                enableLogs: true,
                environmentID: FLAGSMITH_ENV_ID,
                cacheFlags: true,
                realtime: true,
            }, flagsmith: flagsmith },
            React.createElement(AppContainer, null)))));
export default App;
